module.exports = __webpack_public_path__ + "img/chat.628cd99f.svg";